import apiClient from '../apiClient';

class DocumentService {
  constructor(user) {
    this.user = user;
  }

  /**
   * Get all documents for the current user
   */
  async getMyDocuments() {
    const response = await apiClient.get('/documents/my');
    return response || [];
  }

  /**
   * Get public document metadata for a job seeker profile (no download URLs)
   */
  async getDocumentsByProfileId(jobSeekerProfileId) {
    const response = await apiClient.get(`/documents/profile/${jobSeekerProfileId}`);
    return response || [];
  }

  /**
   * Get list of all documents labels/types uploaded for a job seeker profile (no download URLs)
   */
  async getListOfDocumentsByProfileId(jobSeekerProfileId) {
    const response = await apiClient.get(`/documents/profile/${jobSeekerProfileId}/shortlist`);
    return response || [];
  }

  /**
   * Get avatar presigned URL for a job seeker profile
   */
  async getAvatarByProfileId(jobSeekerProfileId) {
    const response = await apiClient.get(`/documents/profile/${jobSeekerProfileId}/avatar`);
    return response || { avatarUrl: null };
  }

  /**
   * Delete avatar for a profile (owner only)
   */
  async deleteAvatarByProfileId(jobSeekerProfileId) {
    return await apiClient.delete(`/documents/profile/${jobSeekerProfileId}/avatar`);
  }

  /**
   * Request a presigned upload URL, then upload the file directly to S3
   */
  async uploadDocument({ jobSeekerProfileId, documentType, documentLabel, ticketNumber, file }) {
    // Step 1: Get presigned upload URL from backend
    const { uploadUrl, document } = await apiClient.post('/documents/upload-url', {
      jobSeekerProfileId,
      documentType,
      fileName: file.name,
      contentType: file.type,
      documentLabel,
      ticketNumber,
    });

    // Step 2: Upload file directly to S3 using the presigned URL
    const uploadResponse = await fetch(uploadUrl, {
      method: 'PUT',
      body: file,
      headers: {
        'Content-Type': file.type,
      },
    });

    if (!uploadResponse.ok) {
      throw new Error('Failed to upload file to storage');
    }

    return document;
  }

  /**
   * Get a presigned download URL for a document (company users)
   */
  async getDownloadUrl(documentId) {
    const response = await apiClient.get(`/documents/${documentId}/download-url`);
    return response;
  }

  /**
   * Delete a document
   */
  async deleteDocument(documentId) {
    return await apiClient.delete(`/documents/${documentId}`);
  }
}

export default DocumentService;
